import { useMemo } from "react"
import { useMapTooltipDisplayData } from "../useMapTooltipDisplayData"

// RepairPlan
export default function RPContent() {
    const { data, displayData } = useMapTooltipDisplayData()
    const { RepairTypeDisplayText, Length } = data ?? {}
    const { RepairStandartWorktTypeString, Rating } = displayData ?? {}

    const formattedLength = typeof Length === 'number'
        ? Length.toFixed(2).replace('.', ',')
        : (Length ?? null)

    const formattedRepairType = useMemo(() => {
        let formattedRepairType = RepairTypeDisplayText
        if (RepairTypeDisplayText && RepairTypeDisplayText.includes(' - ')) {
            formattedRepairType = RepairTypeDisplayText.split(' - ')[1]
        }
        return formattedRepairType
    }, [RepairTypeDisplayText])

    return (
        <>
            <div className="tooltip-info-row">Протяжённость: {formattedLength} км</div>
            <div className="tooltip-info-row">Тип мероприятия: {RepairStandartWorktTypeString ?? 'Не известен'}</div>
            <div className="tooltip-info-row">Вид работ: {formattedRepairType ?? 'Не указаны'}</div>
            <div className="tooltip-info-row">Балльная оценка : {Rating ?? 'Не указана'}</div>
        </>
    )
}
